module.exports = __webpack_public_path__ + "img/google-tag-manager-que-es-750x438.e66819ea.png";